import { useLocation } from '@bedrockio/router';
import { Helmet } from 'react-helmet-async';

// What the browser tab says.
//
// The rule is one sentence: LEAF FIRST, CONTAINER LAST, NOTHING SAID
// TWICE. Inside a project the container is the project — `notes.md |
// Hauser`. Outside one it is the app — `Members | hauser.md`. Never
// both: a three-part title is a breadcrumb nobody can read at tab
// width, and the app's own path strip already shows the full ancestry.
//
// The dedupe is not a nicety. A project named "Hauser" inside an app
// named "Hauser" produced `Hauser | Hauser` on every document, every
// folder, every history page and every settings screen, because the
// suffix was unconditional and the only <Meta> in the workspace lived
// in the shell where it could not know what you were looking at.
//
// The brand is hardcoded rather than read from APP_NAME. APP_NAME is
// deployment configuration and reads correctly in email prose ("The
// Hauser Team"); the wordmark is not configurable — always lowercase,
// always the one filename. components/Logo.jsx makes the same argument
// for the same reason.
const BRAND = 'hauser.md';

export default function Meta(props) {
  const { title, suffix = BRAND, children } = props;
  const { pathname } = useLocation();

  const parts = [...new Set([title, suffix].filter(Boolean))];

  return (
    <Helmet>
      {/*
        The ORIGIN we are actually on, not APP_URL. APP_URL is the
        console, so on a project host this used to claim
        `https://console.hauser.md/d/README.md` — a URL that does not
        exist there. Everything we serve is noindex (see
        serve/middleware/template.js), so no crawler acts on it; it was
        still a false statement in our own markup, left over from before
        project subdomains existed.
      */}
      <link rel="canonical" href={window.location.origin + pathname} />
      <title>{parts.join(' | ')}</title>
      {children}
    </Helmet>
  );
}
